import styled from 'styled-components';

export const FinalPhaseDetails = styled.div`

`
